import _styled from "@emotion/styled/base";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { PlateElement } from 'platejs/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const headingVariants = {
  h1: {
    fontSize: '32px',
    marginTop: '16px'
  },
  h2: {
    fontSize: '24px',
    marginTop: '12px'
  },
  h3: {
    fontSize: '20px'
  },
  h4: {
    fontSize: '18px',
    marginTop: '8px'
  },
  h5: {
    fontSize: '16px',
    marginTop: '8px'
  },
  h6: {
    fontSize: '16px',
    marginTop: '8px'
  }
};
const StyledHeading = /*#__PURE__*/_styled("h1", {
  target: "e1kfgbz20",
  label: "StyledHeading"
})("font-weight:700;line-height:1;margin-top:", props => props.isFirstBlock ? '0' : headingVariants[props.variant].marginTop, ";font-size:", props => headingVariants[props.variant].fontSize, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9SaWNodGV4dENvbnRyb2wvY29tcG9uZW50cy9FbGVtZW50L0hlYWRpbmdFbGVtZW50LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQThCK0IiLCJmaWxlIjoiLi4vLi4vLi4vLi4vLi4vc3JjL1JpY2h0ZXh0Q29udHJvbC9jb21wb25lbnRzL0VsZW1lbnQvSGVhZGluZ0VsZW1lbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgUGxhdGVFbGVtZW50IH0gZnJvbSAncGxhdGVqcy9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmNvbnN0IGhlYWRpbmdWYXJpYW50cyA9IHtcbiAgaDE6IHtcbiAgICBmb250U2l6ZTogJzMycHgnLFxuICAgIG1hcmdpblRvcDogJzE2cHgnLFxuICB9LFxuICBoMjoge1xuICAgIGZvbnRTaXplOiAnMjRweCcsXG4gICAgbWFyZ2luVG9wOiAnMTJweCcsXG4gIH0sXG4gIGgzOiB7XG4gICAgZm9udFNpemU6ICcyMHB4JyxcbiAgfSxcbiAgaDQ6IHtcbiAgICBmb250U2l6ZTogJzE4cHgnLFxuICAgIG1hcmdpblRvcDogJzhweCcsXG4gIH0sXG4gIGg1OiB7XG4gICAgZm9udFNpemU6ICcxNnB4JyxcbiAgICBtYXJnaW5Ub3A6ICc4cHgnLFxuICB9LFxuICBoNjoge1xuICAgIGZvbnRTaXplOiAnMTZweCcsXG4gICAgbWFyZ2luVG9wOiAnOHB4JyxcbiAgfSxcbn07XG5cbmNvbnN0IFN0eWxlZEhlYWRpbmcgPSBzdHlsZWQuaDFgXG4gIGZvbnQtd2VpZ2h0OiA3MDA7XG4gIGxpbmUtaGVpZ2h0OiAxO1xuICBtYXJnaW4tdG9wOiAke3Byb3BzID0+IChwcm9wcy5pc0ZpcnN0QmxvY2sgPyAnMCcgOiBoZWFkaW5nVmFyaWFudHNbcHJvcHMudmFyaWFudF0ubWFyZ2luVG9wKX07XG4gIGZvbnQtc2l6ZTogJHtwcm9wcyA9PiBoZWFkaW5nVmFyaWFudHNbcHJvcHMudmFyaWFudF0uZm9udFNpemV9O1xuYDtcblxuZnVuY3Rpb24gSGVhZGluZ0VsZW1lbnQoeyB2YXJpYW50ID0gJ2gxJywgY2hpbGRyZW4sIC4uLnByb3BzIH0pIHtcbiAgY29uc3QgeyBlbGVtZW50LCBlZGl0b3IgfSA9IHByb3BzO1xuICBjb25zdCBpc0ZpcnN0QmxvY2sgPSBlbGVtZW50ID09PSBlZGl0b3IuY2hpbGRyZW5bMF07XG4gIHJldHVybiAoXG4gICAgPFBsYXRlRWxlbWVudCBhc0NoaWxkIHsuLi5wcm9wc30+XG4gICAgICA8U3R5bGVkSGVhZGluZyBpc0ZpcnN0QmxvY2s9e2lzRmlyc3RCbG9ja30gdmFyaWFudD17dmFyaWFudH0gYXM9e3ZhcmlhbnR9PlxuICAgICAgICB7Y2hpbGRyZW59XG4gICAgICA8L1N0eWxlZEhlYWRpbmc+XG4gICAgPC9QbGF0ZUVsZW1lbnQ+XG4gICk7XG59XG5cbmV4cG9ydCBkZWZhdWx0IEhlYWRpbmdFbGVtZW50O1xuIl19 */"));
function HeadingElement({
  variant = 'h1',
  children,
  ...props
}) {
  const {
    element,
    editor
  } = props;
  const isFirstBlock = element === editor.children[0];
  return ___EmotionJSX(PlateElement, _extends({
    asChild: true
  }, props), ___EmotionJSX(StyledHeading, {
    isFirstBlock: isFirstBlock,
    variant: variant,
    as: variant
  }, children));
}
export default HeadingElement;